import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./location.filter.css";
import axios from "axios";
import {
  fetchKeySearchLocation,
  searchLocation,
  GetFilters,
  fetchKeySearchDynamicLocation,
} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterLocation = (props) => {
  const dispatch = useDispatch();
  const [locationValue, setLocationValue] = useState([]);
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  const [searchtext, setSearch] = useState();



  useEffect(() => {
    var options = [];
    if (locations?.length > 0) {
      for (var i = 0; i < locations?.length; i++) {
        options = [
          ...options,
          {
            value: locations[i].Location,
            value2: locations[i].CityId,
            // value3: locations[i].RegionId,
            count: 0,
          },
        ];
      }

      //append selected cities in suggestions array
      if (props.check && props.check.length > 0) {
        for (var j = 0; j < props.check.length; j++) {
          options = [
            {
              value: props.check?.[j]?.name,
              value2: props.check?.[j]?.ids||props.check?.[j]?.id,
              count: 0,
            },
            ...options,
          ];
        }
      }

      //creating unique array
      var uniqueArr = [];
      options.forEach((option) => {
        if (!uniqueArr.some((item) => item.value === option.value)) {
          uniqueArr.push(option);
        }
      });

      setLocationValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
      // setLocationValue(options);
    } else setLocationValue([]);
  }, [locations]);

  const onChange = (e) => {
    const { value, value2, value3,count, checked } = e.target;
    if (e.target.checked) {
      props.setCheckCityId((prev) => [...prev, parseInt(e.target.value2)]); // Add the value to the array
      props.setcheck((prev) => [
        ...prev,
        {
          name: e.target.value,
          ids: parseInt(e.target.value2),
          count:0,
        },
      ]);
    } else {
      props.setCheckCityId(
        props?.checkCityId.filter((item) => item !== value2)
      ); // Remove the value from the array
      props.setcheck(
        props?.check?.filter((item) => {
          return item.ids !== value2 && item.ids !== value;
        })
      );
    }
    // setValue(JSON.parse(e.target.value))
    // props.setcheck(value.value);
    props.setlocObj(value); //location obj val 1, 2, 3
    // props.setCheckCityId(checkedItems);
    // props.setCheckLocationRegion(parseInt(value.value3));

    if (props.addQuery) {
      props.addQuery("location", e.target.value);
    }
  };

  const onRadioChange = (e) => {
    let value = JSON.parse(e.target.value);
    props.setcheck(value.value);
    props.setlocObj(value);
    props.setCheckLocationCity(parseInt(value.value2));
    props.setCheckLocationRegion(parseInt(value.value3));

    if (props.mobileFilter) {
      props.setVisible(false);
    }

    if (props.addQuery) {
      props.addQuery("location", e.target.value);
    }
  };

  const onLocationSearch = (value) => {
    props?.setEmptyCityInput(value);
    if (Object.keys(props.searchLocationFilter).length) {
      const query = `location=${value}`;
      const params = {
        value: query,
        body: props.searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    } else {
      dispatch(fetchKeySearchLocation(value));
    }
     props?.setEmptyCityInput(value);
  };

  const getCheckedValues = (value2) => {
    if (props?.checkCityId?.includes(value2)) {
      //props?.checkCityId
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="location-suggestion-view" >
      <Input
        onChange={(e) => onLocationSearch(e.target.value)}
        // onChange={(e) => debounce(onLocationSearch(e.target.value))}
        className="filter-search-input"
        placeholder="Search"
        value={props.emptyCityInput}
        prefix={<SearchOutlined />}
      />
      <Space direction="vertical" className={"infinite-scroller mobile-no-scroller"}
      style={{  overflow: "auto", width: "103%", paddingRight: "8px"}}>
        {!searchtext ? (
          <div
            className={`location-lists-container ${
              locationValue?.length > 5 ? "show-scrollbar" : ""
            }`}
          >
            {locationValue?.length ? locationValue.map((items, index) => {
              return items?.value ? (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: index == 0 ? "0px" : "10px",
                  }}
                  key={index}
                >
                  {props.fromFindAMatch ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "inherit",
                      }}
                    >
                      <Radio
                        type={"radio"}
                        key={index}
                        value={JSON.stringify(items)}
                        className="location-radio"
                        onChange={onRadioChange}
                        checked={
                          props?.locObj?.value
                            ? items?.value == props?.locObj?.value
                            : items?.value == props?.locObj
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {" "}
                          <div>{items.value}</div>
                        </div>
                      </Radio>
                      {/* {id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </>} */}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "inherit",
                      }}
                    >
                      <Checkbox
                        checked={getCheckedValues(items.value2)}
                        onChange={onChange}
                        value={items.value}
                        value2={items.value2}
                        value3={items.value3}
                        count = {items.count}
                        key={index}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {" "}
                          <div>{items.value}</div>
                        </div>
                      </Checkbox>
                      {/* {id || props?.fromCandMkt ? null : <> <div className="countDiv">({items?.count})</div> </>} */}
                    </div>
                  )}
                </div>
              ) : null;
            }) : <div style={{display: 'flex', justifyContent: 'center', color: '#7e7e7e'}}> No results found </div> }
          </div>
        ) : (
          searchtext.map((items, index) => {
            return props.fromFindAMatch ? (
              <Radio
                key={index}
                value={JSON.stringify(items)}
                className="location-radio"
                onChange={onChange}
                checked={
                  props?.locObj?.value
                    ? items?.value == props?.locObj?.value
                    : items?.value == props?.locObj
                }
              >
                {items.value}
              </Radio>
            ) : (
              <Checkbox
                checked={getCheckedValues(items.value2)}
                onChange={onChange}
                value={items.value}
                value2={items.value2}
                value3={items.value3}
                count = {items.count}
                key={index}
              >
                {" "}
                {items.value}
              </Checkbox>
            );
          })
        )}
      </Space>      
      {/* </Radio.Group> */}
    </div>
  );
};
export default FilterLocation;
